import React from 'react'
import css from './style.css'

const Button = props => {
  const classNames = [
    css.button,
    props.tall ? css.tall : '',
    props.alt ? css.alt : '',
    props.disabled ? css.disabled : '',
    props.center ? css.center : '',
    props.compare ? css.compare : '',
    props.bottom ? css.bottom : '',
    props.fixedWidth ? css.fixedWidth : '',
    props.transparentBg ? css.transparentBg : ''
  ]

  return (
    <button id={props.buttonId} disabled={props.disabled} className={classNames.join(' ')} onClick={props.onClick}>
      {props.children}
    </button>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/button/index.js